import React from "react";



const PurchaseSection = () => {
  const products = [
      // {
      //   isSoldOut: true,
      //   id: "two_days",
      //   icon: "fa-calendar-alt",
      //   name: "Divas dienas",
      //   description: "Piedalies divu dienu konferencē tiešsaistē 5. decembrī un 6. februārī.",
      //   currency: "EUR",
      //   symbol: "€",
      //   earlyDeadline: "2024-11-17",
      //   prices: {
      //     early: {
      //       standard: 170,
      //       alternate: 110,
      //       link: ""
      //     },
      //     late: {
      //       standard: 170,
      //       alternate: 110,
      //       link: ""
      //     }
      //   },
      //   studentDiscount: 0.3,
      //   notes: "Saņem 30% atlaidi, ja esi students vai studente! Raksti uz latviansfm@gmail.com, pielikumā pievienojot studentu apliecības foto."
      // },
      // {
      //   isSoldOut: true,
      //   id: "one_day_5_dec",
      //   icon: "fa-calendar-alt",
      //   name: "Viena diena - 5. decembris",
      //   description: "Piedalies konferences pirmajā dienā tiešsaistē 5. decembrī.",
      //   currency: "EUR",
      //   symbol: "€",
      //   earlyDeadline: "2024-11-17",
      //   prices: {
      //     early: {
      //       standard: 75,
      //       alternate: 55,
      //       link: ""
      //     },
      //     late: {
      //       standard: 75,
      //       alternate: 55,
      //       link: ""
      //     }
      //   },
      //   studentDiscount: 0.3,
      //   notes: "Saņem 30% atlaidi, ja esi students vai studente! Raksti uz latviansfm@gmail.com, pielikumā pievienojot studentu apliecības foto."
      // },
      {
        isSoldOut: true,
        id: "one_day_6_feb",
        icon: "fa-calendar-alt",
        name: "Viena diena - 6. februāris",
        description: "Piedalies konferences otrajā dienā tiešsaistē 6. februārī.",
        currency: "EUR",
        symbol: "€",
        earlyDeadline: "2024-11-17",
        prices: {
          early: {
            standard: 105,
            alternate: 75,
            link: "https://book.stripe.com/9B6bJ34GUc930fz51Ygw002?locale=lv"
          },
          late: {
            standard: 105,
            alternate: 75,
            link: "https://book.stripe.com/9B6bJ34GUc930fz51Ygw002?locale=lv"
          }
        },
        studentDiscount: 0.3,
        notes: "Saņem 30% atlaidi, ja esi students vai studente! Raksti uz latviansfm@gmail.com, pielikumā pievienojot studentu apliecības foto."
      },
    ]

  return (

    <div className="container mx-auto px-4">
            <div className="text-yellow-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-lsfm-primary-500">
              <i className="fas fa-shopping-bag text-xl"></i>
            </div>
            <h3 className="text-3xl mb-2 font-semibold leading-normal text-white">
              LSFM konference par kaķu medicīnu, uzvedību un labklājību
            </h3>
            <p className="text-lg leading-relaxed mt-4 mb-4 text-white">
              Piedalies vadošajā veterinārmedicīnas konferencē Latvijā, kas notiks 2026. gada 6. februārī. Vietu skaits ierobežots!

            </p>
            <div className="flex flex-wrap justify-start mt-16">
              <div className="flex flex-wrap items-center">
                {products.reverse().map((product, index) => (
                  <div key={index} className="w-full md:w-6/12 px-4 text-center">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                      {/* {index === 0 && <div className="flex  justify-end mt-3 mr-3">
                        <span className="m-3 text-xs inline-flex items-center px-3 py-1 font-bold text-white bg-lsfm-primary-700 rounded-full mb-2">
                          <i className={`fas fa-crown mr-3 text-yellow-500`}></i>
                          Vislabāka vērtība
                        </span>
                      </div>} */}

                      <div className="px-4 py-5 flex-auto">
                        <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                          <i className={`fas ${product.icon}`}></i>
                        </div>
                        <h6 className="text-xl font-semibold">{product.name}</h6>
                        <p className="mt-2 mb-4 text-warmGray-700">
                          {product.description}
                        </p>

                        <div className="text-lg font-bold text-warmGray-800 mb-6">
                          Dalības maksa: <span className="text-teal-600">{product.symbol}{(new Date(product.earlyDeadline + "T23:59:59") >= new Date()) ? product.prices.early.alternate : product.prices.late.alternate}</span>
                        </div>
                        <div className="text-center">
                          {product.isSoldOut ? 
                          <div className="text-lg font-bold text-warmGray-700 mb-6">
                            Izpārdots 🎉
                          </div>
                          :
                          <a
                            href={(new Date(product.earlyDeadline + "T23:59:59") >= new Date()) ? product.prices.early.link : product.prices.late.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-teal-500 text-white active:bg-teal-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
                          >
                            Pirkt biļeti
                          </a>}
                          <p className="mt-10 text-xs">*{product.notes}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
  );
};



export default PurchaseSection;